import { type ViewId, useStudio } from '../store/studio-store';

const VIEWS: Array<{ id: ViewId; label: string }> = [
  { id: 'script', label: 'Script' },
  { id: 'project', label: 'Project' },
  { id: 'assets', label: 'Assets' },
  { id: 'storyboard', label: 'Storyboard' },
  { id: 'canvas', label: 'Canvas' },
  { id: 'render', label: 'Render' },
];

export function TopBar() {
  const view = useStudio((s) => s.view);
  const setView = useStudio((s) => s.setView);
  const toggleDiagnostics = useStudio((s) => s.toggleDiagnostics);
  const diagnosticsOpen = useStudio((s) => s.diagnosticsOpen);

  return (
    <header className="topbar">
      <div className="topbar-brand">
        <span className="brand-mark">🎬</span>
        <span className="brand-name">Cinematic Engine</span>
      </div>
      <nav className="topbar-views">
        {VIEWS.map((v) => (
          <button
            key={v.id}
            type="button"
            className={`view-btn${view === v.id ? ' active' : ''}`}
            onClick={() => setView(v.id)}
          >
            {v.label}
          </button>
        ))}
      </nav>
      <div className="topbar-actions">
        <button
          type="button"
          className={`diag-btn${diagnosticsOpen ? ' active' : ''}`}
          onClick={toggleDiagnostics}
        >
          Diagnostics
        </button>
      </div>
    </header>
  );
}
